/**
 * @prettier
 */
import { createBrowserHistory } from 'history';

export const history: any = createBrowserHistory();
